module.exports = __webpack_public_path__ + "static/img/station.a64d4368.svg";